import React from "react";
import { graphql } from "react-apollo";
import { JobActivitiesQuery } from "../queries/Activities";
import Activity from "./activities/Activity";
import CenteredLoader from "./CenteredLoader";

const renderActivityList = activities =>
  activities.map(activity => (
    <Activity activity={activity} key={activity.id} />
  ));

class JobActivities extends React.Component {
  componentDidMount() {
    if (this.props.refetch) this.props.refetch();
  }

  render() {
    const { loading, error, activities } = this.props;

    if (loading) return <CenteredLoader />;
    if (error) return "Error";
    if (activities.length === 0) return "No activities.";

    return renderActivityList(activities);
  }
}

export default graphql(JobActivitiesQuery, {
  options: ({ match: { params: { jobId } } }) => ({
    variables: { jobId },
    pollInterval: 1000 * 10
  }),
  props: ({ data: { loading, error, activities, refetch } }) => ({
    error,
    loading,
    activities,
    refetch
  })
})(JobActivities);



// WEBPACK FOOTER //
// ./src/components/JobActivities.js